import { replace } from 'react-router-redux';
import { UsersApi } from '../api/UsersApi';
import { getUserSuccess, getUserFailure } from './AccountSetting';
import { loginSuccess, setShowDemoData } from './Signin';
import { SAML_AUTHENTICATED } from '../../constants/ActionTypes'
import { isEnabledDisplayExecutiveList } from '../../utils/planUtils';

const samlAuthenticatedAction = () => ({
  type: SAML_AUTHENTICATED,
});

export function samlAuthenticated() {
  return (dispatch, getState) => {
    dispatch(samlAuthenticatedAction());

    // Signinの処理と同様だが
    // localStorageへの格納、loginSuccessイベントの実行のみ、
    // UsersApiの前ではなく中でやるように変更している
    UsersApi.getUser(dispatch)
      .then((response) => {
        let user = response.data.data;
        dispatch(getUserSuccess(user));

        localStorage.setItem('user', JSON.stringify({ email: user.email, loginTime: new Date() }));
        dispatch(loginSuccess(user));

        const routerState = getState().router.location.state;
        const from = (routerState && routerState.from) ? routerState.from.pathname : null;

        dispatch(setShowDemoData(user));

        if ((user && user.has_letter_orders) || !isEnabledDisplayExecutiveList(user)) {
          dispatch(replace(from ? from : `/order-dashboard`));
        } else {
          dispatch(replace(from ? from : `/executive-list`));
        }
      })
      .catch((error) => {
        dispatch(getUserFailure(error.response))
      })
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/SamlAuthenticated.js